import { useMutation } from '@tanstack/react-query';

import type { MutationConfig } from '@/lib/react-query';
import { api, extractData } from '@/lib/treaty';

type UseUpdateProjectThumbnail = {
  mutationConfig?: MutationConfig<typeof updateProjectThumbnail>;
};

export interface UpdateProjectThumbnail {
  projectId: string;
  imageId: string;
}

export const updateProjectThumbnail = ({ projectId, imageId }: UpdateProjectThumbnail) => {
  return extractData(api.projects({ id: projectId }).thumbnail.put({ imageId }));
};

export const useUpdateProjectThumbnail = ({ mutationConfig }: UseUpdateProjectThumbnail) => {
  return useMutation({
    ...mutationConfig,
    mutationFn: updateProjectThumbnail,
  });
};
